import { Component, Input, OnInit } from '@angular/core';
import { PoDialogService, PoNotificationService, PoTableAction, PoTableColumn, PoUploadFileRestrictions } from '@po-ui/ng-components';
import { ArquivoService } from 'src/app/service/arquivo-service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-util-arquivo',
  templateUrl: './util-arquivo.component.html',
  styleUrls: ['./util-arquivo.component.css']
})
export class UtilArquivo {

  tabelaArquivosItens: any[] = [];
  urlUploadArquivo: string = `${environment.urlGestaoArquivo}/api/arquivo/upload/generico/`;

  @Input() public poUploadFileRestrictions: PoUploadFileRestrictions = { maxFileSize: 10485760, maxFiles: 5 };
  @Input() public empresa: string = "" ;
  @Input() public filial: string = "" ;
  @Input() public alias: string = "" ;
  @Input() public chave: string = "" ;
  @Input() public tipo: string = "" ;
  @Input() public podeExcluir: boolean = true ;
  @Input() public habilitaUpload: boolean = true ;

  constructor(
    private poDialogService: PoDialogService,
    private poNotificationService: PoNotificationService,
    private arquivoService: ArquivoService,
  ) { }


  setFileRestrictions(poUploadFileRestrictions: PoUploadFileRestrictions): void{
    this.poUploadFileRestrictions = poUploadFileRestrictions;
  }

  arquivosLoadDados(alias: string, chave: string, tipo: string = ''): void {

    this.alias = alias;
    this.chave = chave;
    this.tipo = tipo;

    this.tabelaArquivosItens = [];
    this.arquivoService.getArquivoLista(this.empresa, this.filial, alias, chave, tipo).subscribe({
      next: (arquivos) => {
        if (arquivos && arquivos.length) {
          this.tabelaArquivosItens = arquivos.map((arquivo) => {
            return { ...arquivo, link: `${environment.urlGestaoArquivo}/arquivo/generico/${arquivo.pk}` };
          });
        }
      }
    });
  }

  fileExcluirOpenDialogConfirmar(row: any): void {
    this.poDialogService.confirm({
      title: 'Excluir Arquivo',
      message: 'Deseja realmente excluir o arquivo?',
      confirm: () => this.fileExcluir(row)
    });
  }

  fileExcluir(row: any): void {
    this.arquivoService.deleteArquivo(row.pk).subscribe(() => {
      this.arquivosLoadDados(this.alias, this.chave, this.tipo);
    })
  }

  fileEnviadoSucesso(dados: any): void {
      const data = {
        alias: this.alias,
        chave: this.chave,
        tipo: this.tipo,
        arquivoids: dados.body.arquivoids,
        codigo_empresa: '01',
        codigo_filial: '01'
      };
      this.arquivoService.postArquivoAtualizaDados(data).subscribe({
        next: () => {
          this.arquivosLoadDados(this.alias, this.chave, this.tipo);
          this.poNotificationService.success('Arquivos enviados com sucesso.');
        },
        error: () => {
          this.poNotificationService.error('Falha ao enviar o arquivo. Tente novamente ou informe a TI');
        }
      });
  }

  fileDownloads(row: any): void {
    window.open(row.link, '_blank');
  }

  disableBotaoExcluir(): boolean{
    return (!this.podeExcluir);
  }

  public readonly tabelaArquivoColunas: Array<PoTableColumn> = [
    {property: 'pk'       , width: '5%'   , label: 'ID'  , visible: true},
    {property: 'nome'     , width: '30%'  , label: 'Nome', visible: true},
  ]

  public readonly tabelaArquivoAction: Array<PoTableAction> = [
    { label: 'Download', icon: 'po-icon-download', action: this.fileDownloads.bind(this), },
    { label: 'Excluir' , icon: 'po-icon-delete'  , action: this.fileExcluirOpenDialogConfirmar.bind(this), disabled: this.disableBotaoExcluir.bind(this) }
  ];
}
